module.exports = __webpack_public_path__ + "img/ic_burger_magazin.07b9e9b2.svg";